export default "__VITE_ASSET__CnymHjqc__"